import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  /** 'light' (default) for light surfaces; 'dark' for dark drawers. */
  variant?: 'light' | 'dark';
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ variant = 'light' }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('ekubur_language', lng);
  };

  const currentLanguage = i18n.language;

  const btnClass = (lng: string) => {
    const active = currentLanguage === lng;
    if (variant === 'dark') {
      return active
        ? 'bg-[#C2A14D] text-[#171509]'
        : 'text-[#F2EFE6]/60 hover:text-[#F2EFE6]';
    }
    return active
      ? 'bg-primary-100 text-primary-700'
      : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200';
  };

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-2 py-1 text-xs font-medium rounded transition-colors ${btnClass('en')}`}
      >
        EN
      </button>
      <button
        onClick={() => changeLanguage('ms')}
        className={`px-2 py-1 text-xs font-medium rounded transition-colors ${btnClass('ms')}`}
      >
        BM
      </button>
    </div>
  );
};

export default LanguageSwitcher;
